<template>
  <v-card width="100vw" min-height="100vh" class="d-flex flex-column login">
    <v-container
      class="pos-r fill-height d-flex justify-space-between w100p flex-grow-1"
      color="#141515"
    >
      <div class="d-flex justify-space-between w100p h100p">
        <v-row style="margin: 0; position: relative">
          <v-col cols="7" style="padding: 0">
            <v-card class="no-shadow">
              <!-- <div class="logo">
                <img src="@/assets/images/virsody-logo.svg" alt="" />
              </div> -->
              <div class="banner">
                <img src="@/assets/images/signin/signin-banner.svg" alt="" />
              </div>
            </v-card>
          </v-col>
          <v-col cols="5" class="d-flex justify-center align-center">
            <v-card max-width="484" class="login_card px-4 no-shadow">
              <SizeBox height="20" />
              <v-img
                :width="240"
                cover
                src="@/assets/images/virsody-logo-500.svg"
              ></v-img>
              <v-card-text
                style="
                  color: #00caff;
                  font-size: 14px;
                  letter-spacing: 0.03em;
                  padding-left: 0;
                  padding-right: 0;
                "
              >
                Powerful virsody metaverse editor.
              </v-card-text>
              <SizeBox height="30" />
              <v-card-actions class="px-0 d-flex flex-column">
                <a :href="ssoSite" class="button-start text-12px">
                  Start
                </a>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </v-container>

    <v-footer
      color="neutral900"
      min-height="100"
      class="d-flex justify-space-between text-body-2"
    >
      <div class="left">
        <v-avatar>
          <img :src="require(`@/assets/icons/virsody-logo-footer.svg`)" />
        </v-avatar>
        © 2022 Virsody. All Rights Reserved.
      </div>
      <div class="center">
        <a
          href="https://hei-dong-chuang-zao.gitbook.io/virsody-shi-yong-he-yin-si-tiao-kuan/"
          target="_blank"
        >
          使用和隱私條款
        </a>
        <a target="_blank" href="https://virsody.io/pricing">服務方案</a>
        <a
          target="_blank"
          href="https://docs.google.com/forms/d/e/1FAIpQLSden_HR5CpZaWy8K0DiWXfAJh9hPTiqOC6EPIdODmKnpkN2_A/viewform"
        >
          聯絡我們
        </a>
        <a
          target="_blank"
          href="https://hei-dong-chuang-zao.gitbook.io/virsody-guide/"
        >
          使用手冊
        </a>
      </div>
      <div class="right">
        <v-btn
          color="#232323"
          fab
          text
          width="32"
          height="32"
          style="background-color: #232323"
          class="rounded-circle"
          @click="
            goUrl('https://www.youtube.com/channel/UCGqVGy1Wj4qRe7WrlxCxkFQ')
          "
        >
          <v-avatar tile size="17">
            <img :src="require(`@/assets/icons/youtube.svg`)" />
          </v-avatar>
        </v-btn>
        <v-btn
          color="#232323"
          fab
          text
          width="32"
          height="32"
          class="rounded-circle"
          style="background-color: #232323"
          @click="goUrl('https://www.facebook.com/Virsody')"
        >
          <v-avatar tile size="16">
            <img :src="require(`@/assets/icons/facebook-f.svg`)" />
          </v-avatar>
        </v-btn>
        <v-btn
          color="#232323"
          fab
          text
          width="32"
          height="32"
          style="background-color: #232323"
          class="rounded-circle"
          @click="goUrl('https://www.instagram.com/virsody/?hl=zh-tw')"
        >
          <v-avatar tile size="15">
            <img :src="require(`@/assets/icons/instagram.svg`)" />
          </v-avatar>
        </v-btn>
      </div>
    </v-footer>
  </v-card>
</template>

<script>
import { signin, signupCreator } from '@/api/auth/local';
import { sendVerifyEmail, verify } from '@/api/auth';
import ResetFrame from '@/components/Login/ResetFrame.vue';
import ForgetFrame from '@/components/Login/ForgetFrame.vue';
import ResendFrame from '@/components/Login/ResendFrame.vue';

const required = (v) => !!v || '此為必填欄位';

export default {
  data() {
    return {
      googleURL: `${process.env.VUE_APP_API_URL}/auth/google/redirect`,
      isRegister: false,
      required,
      peekPassword: false,
      peekPasswordConfirm: false,
      resendDialog: false,
      resetDialog: false,
      forgetDialog: false,
      isLoading: false,

      account: '',
      nickname: '',
      password: '',
      passwordComfirm: ''
    };
  },
  computed: {
    ssoSite() {
      // const baseUrl =
      //   process.env.NODE_ENV process.env.VUE_APP_BASE_URL;
      const baseUrl = location?.origin || process.env.VUE_APP_BASE_URL;
      const ssoUrl = process.env.VUE_APP_SSO_URL;
      const resultURL = `${ssoUrl}/?redirectURI=${baseUrl}${this.$route.path}&action=login`;
      return resultURL
    }
  },
  methods: {
    submit() {
      const baseUrl = location?.origin || process.env.VUE_APP_BASE_URL;
      const ssoUrl = process.env.VUE_APP_SSO_URL;
      const resultURL = `${ssoUrl}/?redirectURI=${baseUrl}${this.$route.path}?action=login`;
      // window.location.href = resultURL;
      console.log(resultURL);
    }
  }
};
</script>

<style lang="scss" scoped>
svg {
  display: block;
  height: auto;
  margin: 0 auto 4px;
  width: 100%;
}
.login {
  ::v-deep .container {
    padding: 0px;
    border-bottom: 1px solid $neutral600;
    &:before {
      content: '';
      height: 100%;
      display: block;
      width: 1px;
      position: absolute;
      background-color: $neutral600;
      z-index: 2;
      left: 58.25%;
    }
  }
  ::v-deep .v-input--is-focused {
    &.primary--text {
      fieldset {
        color: $primary !important;
      }
    }
    &.error--text {
      fieldset {
        color: #ff5084 !important;
      }
    }
  }
  ::v-deep .v-text-field {
    fieldset {
      color: transparent !important;
    }
  }
  .login_card {
    padding-top: 20px;
    padding-bottom: 20px;
  }
  .button-start {
    padding: 14px 0;
    width: 100%;
    color: #fff;
    background: linear-gradient(
      90deg,
      rgba(0, 182, 240, 1) 0%,
      rgba(0, 240, 211, 1) 50%,
      rgba(0, 240, 211, 1) 100%
    );
    background-size: 250% 100%;
    border-radius: 46px;
    font-weight: bold;
    letter-spacing: 0.02em;
    text-align: center;
    transition: all 0.3s ease;

    &:hover {
      background-position: 100% 0;
    }
  }
  .google-btn {
    width: 40px;
    height: 40px;
  }
  .tips {
    font-size: 14px;
  }
  .rule {
    font-size: 12px;
  }
  footer {
    padding: 0 20px;
    .left {
      font-size: 12px;
      color: #a8a8a8;
      display: flex;
      align-items: center;
      .v-avatar {
        width: 26px !important;
        margin-right: 5px;
        min-width: 26px !important;
      }
    }
    .center {
      a {
        color: $neutral300;
        font-size: 12px;
        margin: 0 10px;
      }
    }
    .right {
      button {
        margin: 0 8px;
      }
    }
  }
  @media (min-width: 960px) {
    .container {
      max-width: initial;
    }
    footer {
      padding: 0 40px;
      .left {
        font-size: 14px;
        .v-avatar {
          margin-right: 15px !important;
        }
      }
      .center {
        a {
          font-size: 14px;
          margin: 0 24px;
        }
      }
    }
  }
  @media (min-width: 1264px) {
    ::v-deep .container {
      max-width: inherit;
    }
    ::v-deep .v-input__slot {
      height: 56px;
    }
    ::v-deep .v-card__actions > .v-btn.v-btn {
      font-size: 1.25rem;
      height: 56px;
    }
    ::v-deep .v-text-field--outlined.v-input--dense {
      .v-label {
        top: 17px;
      }
      .v-label--active {
        transform: translateY(-25px) scale(0.75);
      }
    }
    .google-btn {
      width: 55px;
      height: 55px;
    }
    .tips {
      font-size: 16px;
    }
    .rule {
      font-size: 14px;
    }
  }
  .logo {
    display: flex;
    padding: 40px 40px 35px;
    border-bottom: 1px solid $neutral600;
    align-items: center;
    img {
      max-width: 251px;
      width: 30%;
    }
  }
  .banner {
    display: flex;
    padding: 60px 40px;
    align-items: center;
    img {
      width: 96%;
      max-width: 823px;
    }
  }
  .product_titles {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
}
</style>
